// extracted by mini-css-extract-plugin
module.exports = {"QrDownloader":"qrCode_QrDownloader__26RH_","material":"qrCode_material__27_3b"};